var map = {
	"./arcade.png": 78478,
	"./bingo.png": 66289,
	"./chat.png": 70604,
	"./events.png": 47073,
	"./favorite.png": 80034,
	"./fish.png": 94752,
	"./gameRecords.png": 16248,
	"./hot.png": 6293,
	"./inbox.png": 21576,
	"./live.png": 82064,
	"./poker.png": 79131,
	"./profile.png": 15071,
	"./records.png": 73154,
	"./redeem.png": 34574,
	"./security.png": 56996,
	"./settings.png": 71961,
	"./slot.png": 52966,
	"./sports.png": 61731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15849;